module.exports = __webpack_public_path__ + "static/media/arrow-left-rounded-white.c416aefd.svg";